module.exports = __webpack_public_path__ + "band_9.643b9784.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_9.png
// module id = WixY
// module chunks = 0